module.exports = __webpack_public_path__ + "static/journals-f69cc92cbc3ee18ddcd9c2505ae32672.jpg";